export default "* Ask & Liv-ark med blanke ansigter\n* Laminering af Ask & Liv-ark\n* Modellervoks";